import React, { useEffect, useState } from 'react';
import styles from './styles.module.less';
import payment from '../../../../common/assets/images/payment_screen.jpg';
import { Row, Col, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import logo from '../../../../common/assets/images/LogoHeaer.png';
import { useDispatch, useSelector } from 'react-redux';
// import paymentLogo from '../../../../common/assets/images/payment_success.svg';
import paymentLogo from '../../../../common/assets/images/payment_failure.svg';
import { paymentway, verifyAPI } from '../../redux/slice';
// LogoHeaer
const Payment = () => {
  useEffect(() => {
    document.title = 'Payment failed - Please try again';
  }, []);

  const navigate = useNavigate(); // Initialize navigate
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [hasOpenedRazorpay, setHasOpenedRazorpay] = useState(false);
  const paymentStatus = useSelector((state) => state.paymentgateway);
  const [razorpayOpened, setRazorpayOpened] = useState(false);
  // const handleNavigate = () => {
  //   navigate('/dashboard'); // Navigate to dashboard
  // };
  console.log('paymentStatus', paymentStatus);
  console.log('loading', loading);
  console.log('razorpayOpened', razorpayOpened);

  const handleBackSubmit = () => {
    // navigate('/membership_payment');
    navigate('/dashboard');
    window.location.reload();
  };

  useEffect(() => {
    localStorage.removeItem('razorpayError');
    localStorage.removeItem('paymentCompleted');
    localStorage.removeItem('razorpay_response');
    // localStorage.removeItem('order_create');
  }, []);

  const handleSubmit = () => {
    const storedOrder = JSON.parse(localStorage.getItem('order_create'));

    console.log('storedOrder', storedOrder?.notes?.productName);
    const payload = {
      // trn: crypto.randomUUID(),
      trn: storedOrder.trn || 'N/A',
      amount: storedOrder.amount || 0,
      currency: storedOrder.currency || 'N/A',
      notes: {
        productName: storedOrder?.notes?.productName || 'N/A',
        planType: storedOrder?.notes?.planType || 'N/A',
        customerName: storedOrder?.notes?.customerName || 'N/A',
        customerEmail: storedOrder?.notes?.customerEmail || 'N/A'
      }
    };

    console.log('storedOrder', payload);
    setRazorpayOpened(false);
    dispatch(paymentway(payload));
  };

  useEffect(() => {
    // Check if the page has been reloaded already
    const hasReloaded = sessionStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload(); // Force reload the page
    } else {
      sessionStorage.removeItem('hasReloaded'); // Clear flag after reload
    }
  }, []);

  useEffect(() => {
    if (
      !loading &&
      paymentStatus?.success &&
      paymentStatus.payment_details &&
      !razorpayOpened
    ) {
      console.log('Payment success! Opening Razorpay...');
      openRazorpayCheckout();
      setRazorpayOpened(true); // Mark that Razorpay has been opened
    } else if (loading && paymentStatus?.success === false) {
      setLoading(false);
      alert('Payment failed. Please try again.');
    }
  }, [paymentStatus, loading]); // Runs only when `paymentStatus` updates

  const openRazorpayCheckout = async () => {
    try {
      console.log('Opening Razorpay checkout...');
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        alert('Razorpay SDK failed to load. Check your internet connection.');
        setLoading(false);
        return;
      }

      console.log('Script loaded successfully');

      const orderDetails = paymentStatus.payment_details;
      console.log('Order details for Razorpay:', orderDetails);

      // Setup Razorpay options
      const options = {
        // key: 'rzp_test_8oey15fzuX4stX',
        key: process.env?.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        name: 'Your Company Name',
        description: `Payment for ${orderDetails.notes.productName}`,
        order_id: orderDetails.id, // This is the Razorpay order ID
        handler: async function (response) {
          console.log('Payment successful', response);
          // Handle successful payment
          const resultAction = await dispatch(verifyAPI(response));
          if (verifyAPI.fulfilled.match(resultAction)) {
            console.log('Payment successful', response);
            // You should verify the payment on your backend here
            navigate('/success');
          } else {
            console.error('Payment verification failed', resultAction.payload);
            navigate('/failure'); // Navigate to failure page
          }
        },
        prefill: {
          name: orderDetails.notes.customerName,
          email: orderDetails.notes.customerEmail
        },
        theme: {
          color: '#3399cc'
        },
        modal: {
          ondismiss: function () {
            console.log('Modal dismissed');
            setLoading(false);
            navigate('/failure'); // Redirect on failure or dismissal
          }
        }
      };
      console.log('Razorpay options:', options);
      // Initialize and open Razorpay
      const razorpay = new window.Razorpay(options);
      razorpay.open();
      console.log('Razorpay modal opened');
    } catch (error) {
      console.error('Error opening Razorpay:', error);
      alert('Something went wrong. Please try again later.');
      setLoading(false);
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // This effect runs when payment status changes
  // useEffect(() => {
  //   console.log('Payment status changed:', paymentStatus);
  //   if (paymentStatus.success === true && paymentStatus.payment_details) {
  //     console.log('Successful payment status detected');
  //     // Open Razorpay when we have a successful order response
  //     openRazorpayCheckout();
  //     // setHasOpenedRazorpay(true);
  //   } else if (paymentStatus.success === false) {
  //     setLoading(false);
  //     // Handle payment failure
  //     alert('Failed to create payment. Please try again.');
  //   }
  // }, [paymentStatus]);

  const storedOrder = JSON.parse(localStorage.getItem('order_create'));

  console.log('Retrieved Order:', storedOrder?.trn);

  const TransactionNum = storedOrder?.trn
    ? `ES-${storedOrder?.trn.slice(0, 8)}`
    : 'N/A';

  const rawValue = localStorage.getItem('payment_Amount_GST'); // e.g. "2655000"
  const numberValue = Number(rawValue); // Convert string to number
  const formattedValue = (numberValue / 100).toFixed(2); // Divide by 100 and keep 2 decimal places
  console.log(formattedValue); // Output: "26550.00"

  const currencySymbols = {
    INR: '₹',
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$'
  };

  return (
    <>
      {/* <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} md={6} sm={6} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={payment} />
        </Col> */}

      <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} md={6} sm={6} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={payment} />
        </Col>

        <Col xs={24} xl={13} sm={6} md={6} className={styles.sideheader}>
          <div className={styles.headerload}>
            <img
              src={logo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>

          <div className={styles.paymentLogo}>
            <img src={paymentLogo} alt="" />
          </div>

          <div className={styles.textcenter}>
            <div className={styles.congo}>
              {/* <div className={styles.con}>Congratulations !!</div>
              <div className={styles.upgrade}>You have now been upgraded </div> */}
              <div className={styles.con}>
                We’re Sorry,
                <div className={styles.con}>
                  but your payment couldn`t be processed. !
                </div>
              </div>
              <div className={styles.upgrade}>Please retry the payment. </div>
            </div>

            <div className={styles.transfer}>
              <div className={styles.Tnum}>Transaction ID</div>
              <div className={styles.num}> {TransactionNum} </div>
            </div>

            <div className={styles.transfer}>
              <div className={styles.Tnum}>Amount</div>
              <div className={styles.num1}>
                {/* {storedOrder?.amount} */}
                {/* {storedOrder?.currency && storedOrder?.amount
                  ? `${storedOrder.currency} ${storedOrder.amount}`
                  : 'N/A'} */}
                {currencySymbols[storedOrder?.currency] ||
                (storedOrder?.currency && formattedValue)
                  ? `${
                      currencySymbols[storedOrder?.currency] ||
                      storedOrder?.currency
                    } ${formattedValue}`
                  : 'N/A'}
              </div>
            </div>
            <div className={styles.handlebuttons}>
              <Button className={styles.backbutton} onClick={handleBackSubmit}>
                Back
              </Button>
              <Button className={styles.submitbutton} onClick={handleSubmit}>
                Retry
              </Button>
            </div>
          </div>
          <br />
          <br />

          {/* </Col>
        <Col getter={24}> */}
        </Col>
      </Row>
      <div></div>
    </>
  );
};

export default Payment;
